import Icon from 'components/Icon/Icon';
import { ReactComponent as ChatBaloon } from 'assets/icons/msg_baloon.svg';
import colors from 'style-utils/theme/themeProperties/colors';
import styled from 'styled-components';
import { Span } from 'components/Typography';
import { vivochaEngageChat } from './VivochaSideBanner.utils';
import vivochatMobileBg from '../../../../assets/backgrounds/vivochaMobileBg.png';
import media from 'style-utils/responsive-utils/media/media';
import { useIsAtLeastDesktopBreakpoint } from 'utils/hooks/media-queries';
/* -------------------------------------------------------------------------------------------------
 * STYLES
 * -----------------------------------------------------------------------------------------------*/
const VivochaFixedContainer = styled.div`
  cursor: pointer;
  position: fixed;
  z-index: 2;
  width: 6.6rem;
  height: 6.6rem;
  background: url(${vivochatMobileBg}) center no-repeat;
  bottom: 1rem;
  right: 1rem;

  ${media.desktop`
    bottom: auto;
    right: auto;
    width: auto;
    height: auto;
    display: flex;
    gap: 0.7rem;
    align-items: center;
    left: 0;
    top: 15vh;
    background: ${colors.bgPrimary};
    border-radius: 0 0.5rem 0.5rem 0;
    box-shadow: 2px 2px 16px 0px rgba(0, 0, 0, 0.25);
    padding: 1.6rem;
    writing-mode: vertical-lr;
  `};
`;
/* -------------------------------------------------------------------------------------------------
 * ROOT
 * -----------------------------------------------------------------------------------------------*/
export const VivochaSideBanner = () => {
  const isDesktop = useIsAtLeastDesktopBreakpoint();
  return (
    <VivochaFixedContainer onClick={vivochaEngageChat}>
      {isDesktop && (
        <>
          <Span
            i18nKey="needHelpButton"
            textColor={'white'}
            fontSize={'1.6rem'}
            fontWeight={700}
            // fontFamily={'DM Sans'}
          />
          <Icon svgIconComponent={ChatBaloon} iconSize="1.6rem" />
        </>
      )}
    </VivochaFixedContainer>
  );
};
